export default __webpack_public_path__ + "static/media/strassenbahn-neubauprojekte-wien.956b0a7c.svg";